module.exports = __webpack_public_path__ + "static/ayba-metal-case-study-75f72d2be15ca02819c11b808859dbcc.webp";